<template>
    <el-form ref="formRef" :model="formModel" label-width="auto" :validate-on-rule-change="false" v-bind="formProps" :rules="getRules"
        :class="[inline ? 'inline' : '']">
        <el-row :gutter="gutter">
            <el-col v-for="schema of schemas" :span="schema.span || span" :key="schema.prop">
                <template v-if="schema.formItemSlot">
                    <slot :name="schema.formItemSlot" :model="formModel" :prop="schema.prop"
                        :value="formModel[schema.prop]" :label="schema.label">
                    </slot>
                </template>
                <el-form-item v-else :label="showLabel ? schema.label : ''" :prop="schema.prop">
                    <template v-if="schema.slot">
                        <slot :name="schema.slot" :model="formModel" :prop="schema.prop" :value="formModel[schema.prop]"
                            :label="schema.label">
                        </slot>
                    </template>

                    <el-input v-else-if="schema.component == 'ElInput'" v-model="formModel[schema.prop]"
                        :placeholder="getplaceHolder(schema)" v-bind="schema.componentProps" @clear="handleClear" />

                    <el-checkbox-group v-else-if="schema.component == 'ElCheckbox'" v-bind="schema.componentProps"
                        v-model="formModel[schema.prop]">
                        <el-checkbox v-for="(checkbox, index) of schema.componentProps.options"
                            :label="getOptionsValue(schema, checkbox)" :key="index">
                            {{ getOptionsLabel(schema, checkbox) }}
                        </el-checkbox>
                    </el-checkbox-group>

                    <el-radio-group v-else-if="schema.component == 'ElRadioGroup'" v-bind="schema.componentProps"
                        v-model="formModel[schema.prop]">
                        <el-radio v-for="(radio, index) of schema.componentProps.options" :key="index"
                            :label="getOptionsValue(schema, radio)">
                            {{ getOptionsLabel(schema, radio) }}
                        </el-radio>
                    </el-radio-group>

                    <el-select v-else-if="schema.component == 'ElSelect'" v-bind="schema.componentProps"
                        @clear="handleClear" :placeholder="getplaceHolder(schema)" v-model="formModel[schema.prop]">
                        <el-option v-for="(select, index) of schema.componentProps.options" :key="index"
                            :label="getOptionsLabel(schema, select)" :value="getOptionsValue(schema, select)">
                        </el-option>
                    </el-select>
                    <!-- <el-date-picker v-else-if="schema.component == 'ElDatePicker'" v-model="formModel[schema.prop]"
                        v-bind="schema.componentProps">
                    </el-date-picker> -->

                    <component v-else v-bind="schema.componentProps" v-model="formModel[schema.prop]"
                        :is="schema.component" :placeholder="getplaceHolder(schema)" @clear="handleClear">
                    </component>

                </el-form-item>
            </el-col>
            <el-col :span="2" v-if="submitShow">
                <el-button type="primary" @click="submit">{{ submitText }}</el-button>
            </el-col>
        </el-row>
    </el-form>
</template>

<script>
import * as utils from "./utils"
export default {
    props: {
        formProps: {
            type: Object,
            default: () => { }
        },
        schemas: {
            type: Array
        },
        gutter: {
            type: Number,
            default: 20
        },
        span: {
            type: Number,
            default: 24
        },
        submitShow: {
            type: Boolean,
            default: false
        },
        submitText: {
            type: String,
            default: '搜索'
        },
        inline: {
            type: Boolean,
            default: false
        },
        showLabel: {
            type: Boolean,
            default: true
        }

    },
    data() {
        return {
            formModel: {},
        }
    },
    computed: {
        getRules() {
            const r = this.schemas.reduce((pre, cur) => {
                if (cur.required) {
                    pre[cur.prop] = { required: true, message: this.getplaceHolder(cur), trigger: "change" }
                }
                if (cur.rules) {
                    pre[cur.prop] = cur.rules
                }
                return pre
            }, {})
            return r
        }
    },
    mounted() {
        this.initDefaultValue()
    },
    methods: {
        ...utils,
        initDefaultValue() {
            const obj = {}
            this.schemas.forEach(item => {
                if (item.default !== undefined) {
                    obj[item.prop] = item.default
                }
            })
            this.formModel = obj
        },
        validate() {
            return new Promise((resolve => {
                this.$refs.formRef.validate((v) => {
                    resolve(v)
                })
            }))
        },
        resetFields() {
            this.$refs.formRef.resetFields()
        },
        async submit() {
            const data = await this.validate() ? this.getModelValue() : null
            this.$emit('submit', data)
            return data
        },
        getModelValue() {
            let obj = {}
            for (let key in this.formModel) {
                if (this.formModel[key] !== '' && this.formModel[key] !== null) {
                    const schema = this.schemas.find(i => i.prop == key)
                    if (schema) {
                        obj[key] = schema?.formatter ? schema.formatter(this.formModel) : this.formModel[key];
                    } else {
                        obj[key] = this.formModel[key]
                    }
                }
                else {
                    obj[key] = ''
                }
            }
            return obj
        },
        setFiledsValue(model) {
            const keys = Object.keys(model);
            if (keys.length == 0) {
                Object.keys(this.formModel).forEach((key) => {
                    this.formModel[key] = null;
                });
                return;
            }
            keys.forEach((key) => {
                const schema = this.schemas.find((item) => item.prop == key);
                if (schema) {
                    let val = schema.viewFormatter ? schema.viewFormatter(model) : model[key]
                    this.$set(this.formModel, key, val)
                } else {
                    this.$set(this.formModel, key, model[key])
                }

            });
        },
        setFiledValue(key, value) {
            this.$set(this.formModel, key, value)
        },
        handleClear() {
            this.$emit('clear', this.getModelValue())
        }


    },
}
</script>

<style scoped>
.el-select,
.el-date-editor,
.el-cascader,
.el-input-number {
    width: 100% !important;
}

.inline {}

.inline .el-form-item {
    margin-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/easyForm/index.vue